import { Card, Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import "../index.css";

import { getPageViewsCount } from "../APIs/firebaseDashboardApis";
import { DashboardContext } from "../contexts/DashboardContextProvider";

const PageViewedAnalyticsWidget = ({ propertyIds, dateRange, rangeLabel }) => {
  const { setPageViewsCallback } = useContext(DashboardContext);

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (propertyIds?.length > 0 && dateRange.length > 0) {
      const fetchPageViewsCount = async () => {
        setLoading(true);
        const response = await getPageViewsCount({ propertyIds, dateRange })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setLoading(false);
          });
        setPageViewsCallback(response);
        const tempCount = response.reduce(
          (prev, curr) => prev + (curr.pageViews || 0),
          0
        );
        setCount(tempCount);
      };
      fetchPageViewsCount();
    }
  }, [propertyIds, dateRange, setPageViewsCallback]);

  return (
    <Spin spinning={loading}>
      <Card
        className="dashboard_card"
        title={
          <>
            <i className="fa-regular fa-eye"></i>
            <span className="card_title">Page Views</span>
          </>
        }
      >
        <div className="card-stats-body">
          <p className="stats-body-number-heading">{rangeLabel}</p>
          <p className="stats-body-number">{count}</p>
        </div>
      </Card>
    </Spin>
  );
};

export default React.memo(PageViewedAnalyticsWidget);
